import { EventEmitter, Injectable, Output, Directive } from "@angular/core";
import {IdValue} from "../../models/id-value";

@Directive()
@Injectable()
export class ClassificationService {

  public idValue: IdValue;
  @Output() public change: EventEmitter<any> = new EventEmitter();

  public changeMade() {
    this.change.emit({
      change: true,
      idValue: this.idValue,
    });
  }

}
